/* eslint-disable no-console */
import MicroModal from "micromodal";

export default {
  init() {
    let globalGuests = parseInt($(".qty").val());
    let globalOccupancy = 0;
    let tripDetails = $(".trip-details");

    $("body")
      .on("update_checkout", () => {
        //tripDetails.addClass("loading");
      })
      .on("updated_checkout", () => {
        let order_review = $(".woocommerce-checkout-review-order-table");

        let total = order_review
          .find(".order-total .woocommerce-Price-amount")
          .html();
        let deposit_amount = order_review.find(".order-paid .amount").html();
        let amount_due = order_review.find(".order-remaining .amount").html();
        let feesTar = tripDetails.find(".fees-tar");
        feesTar.html("");
        let fees = order_review.find("tr.fee");
        let coupons = order_review.find("tr.coupon");
        let feeRender = "";

        fees.each(function () {
          feeRender += `<p class="text-xx-small uppercase dark-grey uppercase spaced">${$(
            this
          )
            .find("th")
            .text()}</p>
        <p class="text-x-small uppercase spaced">${$(this)
          .find(".amount")
          .html()}</p>
        <hr>`;
        });
        coupons.each(function () {
          feeRender += `<p class="text-xx-small uppercase dark-grey uppercase spaced">PROMO: ${$(
            this
          )
            .find("th")
            .text()}</p>
        <p class="text-x-small uppercase spaced">${$(this)
          .find(".amount")
          .html()}</p>
        <hr>`;
        });
        feesTar.html(feeRender);
        tripDetails.find(".total").html(total);
        if (deposit_amount) {
          $(".checkout--gateways--total").html(deposit_amount);
        } else {
          $(".checkout--gateways--total").html(total);
        }
        tripDetails.find(".deposit-amount").html(deposit_amount);
        tripDetails.find(".amount-due").html(amount_due);
        getActiveGateway();
      });

    function getActiveGateway() {
      let activeGateway = $(".wc_payment_methods")
        .find('input[name="payment_method"]:checked')
        .val();
      $(".checkout--gateways--single").removeClass("active");
      $(`.checkout--gateways--single[data-type="${activeGateway}"]`).addClass(
        "active"
      );
    }

    $("body").on("click", ".checkout--gateways--box", function () {
      let gateways = $(".wc_payment_methods");
      let type = $(this).parent().attr("data-type");
      gateways
        .find(`#payment_method_${type}`)
        .prop("checked", true)
        .trigger("change")
        .trigger("click");
      getActiveGateway();
      // $("body").trigger("update_checkout");
    });

    // removed .checkout--sidebar--item --- validation would be way more complex, can jump ahead re of target etc
    $(".checkout-change-view").on("click", function () {
      let target = $(this).data("target");
      let check = $(this).data("check");

      if (check === "guests") {
        saveTripMeta();
        let valid = true;
        if (globalGuests > globalOccupancy) {
          $(".occupancy-input").addClass("invalid");
          valid = false;
        } else {
          $(".occupancy-input").removeClass("invalid");
        }
        let formValid = checkFormValid("form.form-trip-meta-guests");
        let formEPDValid = checkFormValid(
          "form.form-trip-early-payment-discount"
        );
        if (!formEPDValid) {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop:
                $("form.form-trip-early-payment-discount").first().offset()
                  .top - 50,
            },
            1000
          );
          return;
        } else if (!valid || !formValid) {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop:
                $("form.form-trip-meta-guests .invalid").first().offset().top -
                50,
            },
            1000
          );
          return;
        }
      } else if (check === "rooming") {
        let formValid = checkFormValid("form.form-trip-meta-rooming");

        if (!formValid) {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop:
                $("form.form-trip-meta-rooming .invalid").first().offset().top -
                50,
            },
            1000
          );
          return;
        }
        saveTripMeta();
      } else if (check === "bikes") {
        saveTripMeta();
        let formValid = checkFormValid("form.form-trip-meta-bikes");

        if (!formValid) {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop:
                $("form.form-trip-meta-bikes .invalid").first().offset().top -
                50,
            },
            1000
          );
          return;
        }
      } else if (target === "final") {
        $("body").find("#place_order").trigger("click");
        return;
      }

      $(".checkout--content__item.active").removeClass("active");
      $(".checkout--sidebar--item.active").removeClass("active");
      $(`.checkout--sidebar--item[data-target="${target}"]`).addClass("active");
      $(`.checkout--content__${target}`).addClass("active");
      window.scrollTo(0, 0);
    });

    $(
      "form.form-trip-meta-guests input, form.form-trip-meta-guests select,form.form-trip-meta-bikes input, form.form-trip-meta-bikes select, form.form-trip-meta-rooming select, form.form-trip-early-payment-discount input"
    ).on("change", function () {
      saveTripMeta();
    });

    // Advanced Reservation form 

    $("form.woocommerce-checkout--adv-res input, form.woocommerce-checkout--adv-res select").on('change', function() {
      saveAdvResTripMeta();
    });

    function saveAdvResTripMeta() {
      let tripMeta = {};
      if ($("form.form-trip-early-payment-discount").length) {
        tripMeta.early_payment_discount = $("#early_payment_discount").is(
          ":checked"
        );  
      } else {
        tripMeta.early_payment_discount = false;
      }

      // Advance reservation additional interest

      const additonalInterest = $('input[name="advanced-reservation-interest[]"]');
      const interestedIn = [];
      if (additonalInterest) {
        additonalInterest.each(function () {
          if ( $(this).is(':checked') )
          {
            interestedIn.push($(this).val());
          }
        });
        if (interestedIn.length)
        {
          tripMeta.advanced_reservation_additional_interest = interestedIn;
        }
      }

      const formObjGuests = $("form.woocommerce-checkout--adv-res").serializeObject();

      tripMeta.guests = formObjGuests.guests;

      const riderType = $('select[name="rider_type"]');

      if(riderType) 
      {
        tripMeta.guests[0].rider_type = riderType.find(':selected').val(); 
      }
      
      if ($("form.form-trip-meta-bikes").length) {
        const formObjBikes = $("form.form-trip-meta-bikes").serializeObject();
        tripMeta.bikes = formObjBikes.bikes;
      }
      if ($("form.form-trip-meta-rooming").length) {
        const formObjRooming = $(
          "form.form-trip-meta-rooming"
        ).serializeObject();
        tripMeta.rooming = formObjRooming.rooming;
      }

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "update_trip_meta",
          form_data: tripMeta,
        },
        success: function (response) {
          var data = JSON.parse(response);
          if (data.rooming) {
            $(".checkout--content__rooming form").html(data.rooming);
          }
          $("body").trigger("update_checkout");
        },
      });

      for (var g = 0; g < tripMeta.guests.length; g++) {
        $(
          `.table-book-bike-rental tbody tr[data-guest=${g}] .guest-name, #guest_name_${g}`
        ).html(getName(g));
        if (tripMeta.bikes) {
          let tr = $(`.table-book-bike-rental tbody tr[data-guest=${g}]`);
          if (tripMeta.guests[g].rider_type == "non-rider") {
            tr.addClass("non-rider");
            tr.removeClass("rider");
            tr.removeClass("own-bike");
            tr.find("select").addClass("disabled");
            tr.find("select[required]")
              .removeAttr("required")
              .addClass("disabled-required");

              tr.find(".available_bikes input").removeAttr("required").addClass("disabled");
              tr.find('.radio-wrap input').removeAttr("required").addClass("disabled");
              tr.find("input.own-rent-field").removeAttr("required").addClass("disabled").attr('checked', false);
              
          } else if (tripMeta.bikes[g].bike_rental == "own") {
            tr.addClass("own-bike").addClass("rider").removeClass("non-rider");
            tr.find("select").not(".rent-own").addClass("disabled");
            tr.find("select[required]")
              .not(".rent-own")
              .removeAttr("required")
              .addClass("disabled-required");
            tr.find("select.rent-own.disabled").removeClass("disabled");
            tr.find("select.rent-own.disabled-required")
              .attr("required", "required")
              .removeClass("disabled-required");
              tr.find(".available_bikes input").removeAttr("required").addClass("disabled");
              tr.find('.radio-wrap input').removeAttr("required").addClass("disabled");
              tr.find("input.own-rent-field").removeAttr("required").addClass("disabled");

          } else {
            tr.removeClass("non-rider")
              .removeClass("own-bike")
              .addClass("rider");
            tr.find("select.disabled").removeClass("disabled");
            tr.find("select.disabled-required")
              .attr("required", "required")
              .removeClass("disabled-required");

            tr.find('.radio-wrap input').prop('required',true).removeClass("disabled");
            tr.find(".available_bikes input").prop('required',true).removeClass("disabled");
            tr.find("input.own-rent-field").prop('required',true).removeClass("disabled");  

            
          }
        }
      }
    }

    function checkFormValid(form) {
      let valid = true;
      $(form + " select[required], " + form + " input[required]")
        .not(".disabled")
        .each(function () {
          if ($(this).val() == "") {
            $(this).parent().addClass("invalid");
            if (
              $(this).parent().parent().hasClass("checkout-guest--item--edit")
            ) {
              $(this).parent().parent().parent().addClass("open");
            }

            if($(this).hasClass('bike-sel-field')){
              $('.js-bike-selection-toggle').addClass('open');
              $('.hide-toggle').addClass('open');
            }
            
            valid = false;
          } else if ($(this).parent().parent().hasClass("radios")) {
            var l = "input[name='" + $(this).prop("name") + "']:checked";
            if ($(l).length === 0) {
              $(this).parent().addClass("invalid");

              valid = false;
            } else {
              $(this).parent().removeClass("invalid");
            }
          } else {
            $(this).parent().removeClass("invalid");
          }
        });

      $(form + " select[data-unique]")
        .not(".disabled")
        .each(function () {
          var val = $(this).val();
          var key = $(this).data("unique");
          $(form + " select[data-unique='" + key + "']")
            .not(".disabled")
            .not(this)
            .each(function () {
              if (val === $(this).val()) {
                $(this).parent().addClass("invalid");
                if (
                  $(this)
                    .parent()
                    .parent()
                    .hasClass("checkout-guest--item--edit")
                ) {
                  $(this).parent().parent().parent().addClass("open");
                }
                valid = false;
              } else {
                $(this).parent().removeClass("invalid");
              }
            });
        });

      $(".checkout-guest--item").each(function () {
        var name =
          $(this).find(".guest_first_name").val() +
          " " +
          $(this).find(".guest_last_name").val();

        $(".checkout-guest--item")
          .not(this)
          .each(function () {
            var otherName =
              $(this).find(".guest_first_name").val() +
              " " +
              $(this).find(".guest_last_name").val();
            if (name === otherName) {
              $(this).addClass("duplicate open");
              valid = false;
            } else {
              $(this).removeClass("duplicate");
            }
          });
      });
      return valid;
    }

    function getName(guest) {
      let fname = $("#first_name_" + guest).val();
      let lname = $("#last_name_" + guest).val();
      return fname && lname ? fname + " " + lname : "New Guest " + guest;
    }

    $("form.form-trip-meta-guests").on("submit", function (e) {
      e.preventDefault();
      saveTripMeta();
    });

    function saveTripMeta() {
      let tripMeta = {};
      if ($("form.form-trip-early-payment-discount").length) {
        tripMeta.early_payment_discount = $("#early_payment_discount").is(
          ":checked"
        );  
      } else {
        tripMeta.early_payment_discount = false;
      }

      // Advance reservation additional interest

      const additonalInterest = $('input[name="advanced-reservation-interest[]"]');
      const interestedIn = [];
      if (additonalInterest) {
        additonalInterest.each(function () {
          if ( $(this).is(':checked') )
          {
            interestedIn.push($(this).val());
          }
        });
        if (interestedIn.length)
        {
          tripMeta.advanced_reservation_additional_interest = interestedIn;
        }
      }

      const formObjGuests = $("form.form-trip-meta-guests").serializeObject();

      tripMeta.guests = formObjGuests.guests;
      tripMeta.occupancy = formObjGuests.occupancy;

      if ($("form.form-trip-meta-bikes").length) {
        const formObjBikes = $("form.form-trip-meta-bikes").serializeObject();
        tripMeta.bikes = formObjBikes.bikes;
      }
      if ($("form.form-trip-meta-rooming").length) {
        const formObjRooming = $(
          "form.form-trip-meta-rooming"
        ).serializeObject();
        tripMeta.rooming = formObjRooming.rooming;
      }
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "update_trip_meta",
          form_data: tripMeta,
        },
        success: function (response) {
          var data = JSON.parse(response);
          if (data.rooming) {
            $(".checkout--content__rooming form").html(data.rooming);
          }
          $("body").trigger("update_checkout");
        },
      });

      for (var g = 0; g < tripMeta.guests.length; g++) {
        $(
          `.table-book-bike-rental tbody tr[data-guest=${g}] .guest-name, #guest_name_${g}`
        ).html(getName(g));
        if (tripMeta.bikes) {
          let tr = $(`.table-book-bike-rental tbody tr[data-guest=${g}]`);
          if (tripMeta.guests[g].rider_type == "non-rider") {
            tr.addClass("non-rider");
            tr.removeClass("rider");
            tr.removeClass("own-bike");
            tr.find("select").addClass("disabled");
            tr.find("select[required]")
              .removeAttr("required")
              .addClass("disabled-required");

              tr.find(".available_bikes input").removeAttr("required").addClass("disabled");
              tr.find('.radio-wrap input').removeAttr("required").addClass("disabled");
              tr.find("input.own-rent-field").removeAttr("required").addClass("disabled").attr('checked', false);
              
          } else if (tripMeta.bikes[g].bike_rental == "own") {
            tr.addClass("own-bike").addClass("rider").removeClass("non-rider");
            tr.find("select").not(".rent-own").addClass("disabled");
            tr.find("select[required]")
              .not(".rent-own")
              .removeAttr("required")
              .addClass("disabled-required");
            tr.find("select.rent-own.disabled").removeClass("disabled");
            tr.find("select.rent-own.disabled-required")
              .attr("required", "required")
              .removeClass("disabled-required");
              tr.find(".available_bikes input").removeAttr("required").addClass("disabled");
              tr.find('.radio-wrap input').removeAttr("required").addClass("disabled");
              tr.find("input.own-rent-field").removeAttr("required").addClass("disabled");

          } else {
            tr.removeClass("non-rider")
              .removeClass("own-bike")
              .addClass("rider");
            tr.find("select.disabled").removeClass("disabled");
            tr.find("select.disabled-required")
              .attr("required", "required")
              .removeClass("disabled-required");

            tr.find('.radio-wrap input').prop('required',true).removeClass("disabled");
            tr.find(".available_bikes input").prop('required',true).removeClass("disabled");
            tr.find("input.own-rent-field").prop('required',true).removeClass("disabled");  

            
          }
        }
      }
    }

    $('.js-bike-selection-toggle').on('click', function(){
      $(this).toggleClass('open');
      let elements = $(this).parent().find('.hide-toggle');
      elements.toggleClass('open');
    })


    $(".bike-select").on("change", function () {

      let selected = $(this);
      let bikeSizesSelect = $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .find("select.bike-size-select");
 
      let s = selected.data("bikesizes");
      let guide_ref = selected.data("sizeguide");

      if(guide_ref != null){
        bikeSizesSelect.parent().find('.js-guide_trigger .info-h').get(0).setAttribute('data-trigger-sizetable',guide_ref);
        MicroModal.init();
      }

      let newOptions = bikeSizesSelect.find("option").first()[0].outerHTML;
      for (let i = 0; i < s.length; i++) {
        newOptions += `<option value="${s[i]}">${s[i]}</option>`;
      }
      newOptions += bikeSizesSelect.find("option").last()[0].outerHTML;
      bikeSizesSelect.html(newOptions);

    });

    $('.js-guide_trigger').on('click',function(){
      let $table;
      $table = $(this).find('span').get(0).getAttribute('data-trigger-sizetable');
      if($table){
        MicroModal.show($table);
      }
    })

    // Guest Count
    let qty = $(".qty");
    $(".guest-count--minus").on("click", () => {
      qty.val(parseInt(qty.val()) - 1).trigger("change");
    });

    $(".guest-count--plus").on("click", () => {
      qty.val(parseInt(qty.val()) + 1).trigger("change");
    });

    qty.on("change", () => {
      if (qty.val() < 7) $(".checkout--wrap").addClass("loading");
      $('button[name="update_cart"]').trigger("click");
    });

    // Occupancy
    update_occ_views();

    function update_occ_views() {
      $(".checkout--wrap").addClass("loading");
      let guests = $(".occupancy-grid").attr("data-guests");
      let avail = guests;

      $(".occupancy-grid--item input").each(function () {
        avail -=
          parseInt($(this).attr("data-covers")) * parseInt($(this).val());
      });
      $(".occupancy-grid--item input").each(function () {
        let covers = $(this).attr("data-covers");
        if (covers <= guests) {
          $(this).parent().parent().addClass("available");
        }
        if (covers > avail) {
          $(this).parent().parent().addClass("no-add");
        } else {
          $(this).parent().parent().removeClass("no-add");
        }
        
        if ( $(this).val() > guests )
        {
          $(this).val(parseInt($(this).val()) - 1).trigger("change");
          $(this).siblings('.occupancy-controls--value').html(parseInt($(this).val()));
        }

      });
      $(".occupancy-grid").attr("data-available", avail);
      globalOccupancy = guests - avail;
      setTimeout(() => {
        $(".checkout--wrap").removeClass("loading");
      }, 500);
    }

    $(".occupancy-controls--minus").on("click", function () {
      let type = $(this).parent().attr("data-type");
      let inp = $(`#occ_${type}`);
      if (inp.val() > 0) {
        inp.val(parseInt(inp.val()) - 1).trigger("change");
      }
      $(".occ_" + type + " .occupancy-controls--value").html(inp.val());
      update_occ_views();
    });

    $(".occupancy-controls--plus").on("click", function () {
      let type = $(this).parent().attr("data-type");
      let inp = $(`#occ_${type}`);
      inp.val(parseInt(inp.val()) + 1).trigger("change");
      $(".occ_" + type + " .occupancy-controls--value").html(inp.val());
      update_occ_views();
    });

    $(".checkout-guest--item--top").on("click", function () {
      $(this).parent().toggleClass("open");
    });

    $(".checkout-guest--item--drop--wrap, .rider-options").on("click", (e) => {
      e.stopPropagation();
    });

    $(".checkout-guest--item--drop").on("change", function () {
      if ($(this).val()) {
        let user = $(this).find(":selected");
        let ix = $(this).data("guest");
        $("#first_name_" + ix).val(user.data("first_name"));
        $("#last_name_" + ix).val(user.data("last_name"));
        $("#dob_" + ix).val(user.data("dob"));
        $("#gender_" + ix).val(user.data("gender"));
        $("#email_" + ix).val(user.data("email"));
        $("#phone_" + ix).val(user.data("phone"));
        $("#relation_" + ix).val(user.data("relation"));
        saveTripMeta();
      }
    });

    $("body").trigger("updated_checkout");

    // Checkout Login

    $(".checkout-login-form").on("submit", function (e) {
      e.preventDefault();
      let msg = $(".checkout-login-error");
      msg.css("display", "none").empty();
      let user = $(".checkout-login-user").val();
      let pass = $(".checkout-login-pass").val();

      if (!user || !pass) {
        ajax_login_fail("Username / Email and Password are required");
      } else {
        ajax_login(user, pass);
      }
    });

    function ajax_login_fail(error) {
      let msg = $(".checkout-login-error");
      msg.css("display", "block").html(error);
      $(".checkout--wrap").removeClass("loading");
    }

    // Ajax User
    function ajax_login(user, pass) {
      $(".checkout--wrap").addClass("loading");
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "login_checkout",
          user: user,
          pass: pass,
        },
        success: function (response) {
          let res = JSON.parse(response);
          $(".checkout--wrap").removeClass("loading");
          if (res.error) {
            ajax_login_fail(res.error);
          } else {
            location.reload();
          }
        },
        error: function () {
          alert("error");
          $(".checkout--wrap").removeClass("loading");
        },
      });
    }

    $(".checkout-register-form").on("submit", function (e) {
      e.preventDefault();
      let msg = $(".checkout-register-error");
      msg.css("display", "none").empty();
      let first_name = $(".checkout-register-first-name").val();
      let last_name = $(".checkout-register-last-name").val();
      let user = $(".checkout-register-user").val();
      let pass = $(".checkout-register-pass").val();

      if (!user || !pass || !first_name || !last_name) {
        ajax_register_fail("Username / Email and Password are required");
      } else {
        // console.log(user, pass, first_name, last_name); // eslint-disable-line
        ajax_register(user, pass, first_name, last_name);
      }
    });

    function ajax_register_fail(error) {
      let msg = $(".checkout-register-error");
      msg.css("display", "block").html(error);
      $(".checkout--wrap").removeClass("loading");
    }

    /* eslint-disable */

    // Ajax User
    function ajax_register(user, pass, first_name, last_name) {
      $(".checkout--wrap").addClass("loading");
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "register_checkout",
          user: user,
          pass: pass,
          first_name: first_name,
          last_name: last_name,
        },
        success: function (response) {
          let res = JSON.parse(response);
          if (!res.created) {
            ajax_register_fail(res.message);
          } else {
            location.reload();
          }
        },
        error: function () {
          alert("error");
          $(".checkout--wrap").removeClass("loading");
        },
      });
    }
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/checkout.js